/**
 * @file 蒙层组件
 * @author mengchen <mengchen@babytree-inc.com>
 */
import React from 'react';
import './index.scss';

const Mask = ({
  children,
  backgroundColor = 'rgba(0, 0, 0, 0.4)',
  zIndex = 999,
  onClick = function () {}
}) => (
  <div
    id="component-mask"
    style={{ backgroundColor, zIndex }}
    onClick={(event) => {
      onClick(event);
    }}
  >
    {children}
  </div>
);

export default Mask;
